import React from 'react';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
import './DragHandle.scss';

export interface DragHandleProps {
  onDragStart?: (e: React.DragEvent<HTMLSpanElement>) => void;
  isActive?: boolean;
  className?: string;
}

export const DragHandle: React.FC<DragHandleProps> = ({
  onDragStart,
  isActive = false,
  className = ''
}) => {
  return (
    <span
      className={`cmx-drag-handle${isActive ? ' cmx-drag-handle--active' : ''} ${className}`.trim()}
      draggable
      onDragStart={onDragStart}
      role="button"
      aria-label="Drag to reorder"
      tabIndex={0}
      data-testid="drag-handle"
    >
      <BiomeIcon iconName={IconName.Gripper} titleText="Drag to reorder" />
    </span>
  );
};

DragHandle.displayName = 'DragHandle';
export default DragHandle;
